
import { Base } from '../base-component';

import './button.component.scss';

export class Button extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/button/button.component.ts